var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed z-30 bottom-0 left-0 right-0 bg-white h-28 border-t-1 border-gray-lighter flex justify-center items-center px-6 lg:hidden"},[_c('OButton',{staticClass:"max-w-screen-sm flex-1",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }